import React, { useState } from "react";

export const MapControlButtons = ({ baseType,
    setBaseType,
    showTerrain,
    setShowTerrain,
    setLastSelectedBaseType,
    showLabels,
    setShowLabels }) => {

    const [activateShowLabels, setActivateShowLabels] = useState(false);
    const [activateTerrain, setActivateTerrain] = useState(false);
    const isMobile = window.innerWidth < 850;
    const buttonControlParentStyle = {
        position: "absolute",
        bottom: isMobile ? 35 : 20,
        right: 60,
        zIndex: isMobile ? undefined : 10,
        background: "rgba(255,255,255,0.95)",
        borderRadius: "6px",
        padding: "10px 14px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
        fontFamily: "sans-serif",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
    }

    const mapButtonStyle = {
        fontWeight: baseType === "roadmap" ? "bold" : "normal",
        background: "none",
        border: "none",
        cursor: "pointer",
        fontSize: "1rem",
        padding: "4px 8px",
    }

    const mapTerrainStyle = {
        fontSize: "0.9rem",
        cursor: "pointer",
        marginLeft: "10px",
        marginTop: "3px",
    }

    const satelliteStyle = {
        fontWeight: baseType === "satellite" ? "bold" : "normal",
        background: "none",
        border: "none",
        cursor: "pointer",
        fontSize: "1rem",
        padding: "4px 8px",
    }

    const satelliteLabelsStyle = {
        fontSize: "0.9rem",
        cursor: "pointer",
        marginLeft: "10px",
        marginTop: "3px",
    }

    const handleOnMapClick = () => {
        setBaseType((prev) => (prev === "roadmap" ? "" : "roadmap"));
        setLastSelectedBaseType("roadmap");
        localStorage.setItem("mapBaseType", "roadmap");
        setActivateTerrain(true);
        setActivateShowLabels(false);
    }

    const handleOnMapTerrainClick = (e) => {
        setShowTerrain(e.target.checked);
        localStorage.setItem("mapTerrain", e.target.checked);
        localStorage.setItem("mapBaseType", "roadmap");
        localStorage.setItem("mapLabels", null);
        setActivateTerrain(false);
    }

    const handleOnSatelliteClick = () => {
        setBaseType((prev) => (prev === "satellite" ? "" : "satellite"));
        setLastSelectedBaseType("satellite");
        localStorage.setItem("mapBaseType", "satellite");
        setActivateShowLabels(true);
        setActivateTerrain(false);
    }
    const handleOnSatelliteLabelsClick = (e) => {
        setShowLabels(e.target.checked);
        localStorage.setItem("mapLabels", e.target.checked);
        localStorage.setItem("mapTerrain", null);
        localStorage.setItem("mapBaseType", "satellite");
        setActivateShowLabels(false);
    }

    return (
        <div style={buttonControlParentStyle}>
            <div style={{ display: "flex", gap: "10px" }}>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                    <button onClick={handleOnMapClick} style={mapButtonStyle}>
                        Map
                    </button>

                    {activateTerrain && (
                        <label style={mapTerrainStyle}>
                            <input
                                type="checkbox"
                                checked={showTerrain}
                                onChange={(e) => handleOnMapTerrainClick(e)}
                            />{" "}
                            Terrain
                        </label>
                    )}
                </div>

                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                    <button onClick={handleOnSatelliteClick} style={satelliteStyle}>
                        Satellite
                    </button>

                    {activateShowLabels && (
                        <label style={satelliteLabelsStyle}>
                            <input
                                type="checkbox"
                                checked={showLabels}
                                onChange={(e) => handleOnSatelliteLabelsClick(e)}
                            />{" "}
                            Labels
                        </label>
                    )}
                </div>
            </div>
        </div>
    )
}